import React, { FC, HTMLAttributes } from 'react'

import t from 'prop-types'
import styled from 'styled-components'

import { pulse } from '../../styles/keyframes'

export interface PlaceholderProps extends HTMLAttributes<HTMLDivElement> {}

export const Placeholder: FC<PlaceholderProps> = () => {
  return <E data-testid="placeholder" />
}

Placeholder.propTypes = {
  children: t.node
}

Placeholder.defaultProps = {
  children: null
}

const E = styled.div`
  animation: ${pulse} 1s infinite;
  min-height: 1.5em;
  display: block;
  width: 100%;
`
